import FileUpload from '@cob/ui-genesis/helpers/cob.file-upload.js'
import RecordmImporterStatsP from './recordm.importer.presenter.stats.js'
import {sprintf} from "sprintf-js"
import tmpl_file_upload from '../templates/recordm-importer-upload-dialog.dot'

const RecordmImporterP = function(core, definitionName, importerName, customImportMsg, type) {
    let abortUri;

    const _stop = function() {
        statsP.stop();
        fuP.stop();
    };

    const _showImportStats = function(importId, name, abortable) {
      fuP.hideUploadForm();
      fuP.hideUploadBtn();
      statsP.start(fuP.getContainer(), name, importId, abortable ? abortUri : undefined);
    };

    const fupCbs = {
        uploadSuccessful: function(fileName, response) {
            const json = JSON.parse(response.result);
            const importId = json.import_id;
            const abortable = json.abortable;

            _showImportStats(importId, fileName, abortable);
        },
        cancel:_stop
    };

    const fupOpts = {
        timeout: 5 * 60 * 1000, // 5min timeout, for slower connections
        allowedFileExtensions: ["xls", "xlsx"],
        closeOnSuccess: false,
        closeOnFail: false,
        tmpl: tmpl_file_upload,
        importerName: importerName,
        customImportMsg: customImportMsg
    };

    if(definitionName){
        fupOpts.dialogTitle = sprintf(core.translateString("recordm.search", "import.dialog-title"), definitionName);
    }

    const fuP = new FileUpload.UploadFileP(core, fupCbs, fupOpts);

    const statsP = new RecordmImporterStatsP(core, {});

    return{
        start: function(url) {
          if(!type || type === "excel"){
            abortUri = url.replace(/file\?def=.*/, "import");
            fuP.start(url);
            return
          }

          if (type === "http") {
            // the fetch is triggering the http importer and on a successful response
            // it will show the import statistics
            fetch(url, { method: "POST" })
              .then((response) => response.json())
              .then((json) => {
                const importId = json.import_id;

                fuP.start(url);
                _showImportStats(importId, importerName);
              });
          }

        },
        stop: _stop
    };
};

export default RecordmImporterP;

